/* Core & libraries */
import React from "react";

/* Helpers, constants, custom methods, internal libraries */
import { AIRLINES, APP_ENVIRONMENT } from "../constants/appConstants";
import { useUserContext, useUserUpdateContext } from "../contexts/userContext";

/* Components */
/* Styles */

export const useAnalytics = () => {

  let dcfSmartWebService;

  const TEALIUM_PROFILE = "main";
  const TEALIUM_ENV = APP_ENVIRONMENT === "PROD" ? "prod" : "qa";
  const SITE_INDICATOR = 'universalconnect';
  const APP_ALIAS = 'SMB';
  const userContext = useUserContext();
  const setUserContext = useUserUpdateContext();

  const initAnalytics = async (data, dcfCallType, tealiumEventType) => {

    if (userContext?.userInfo?.providerInfo?.providerCode === AIRLINES.AA) {

      if (userContext?.initAnalytics) {
        updateAnalytics(data, 'Update Call', tealiumEventType)
      } else {
        if (!dcfSmartWebService) {
          await window.customElements.whenDefined('dcf-smartweb-service');
          dcfSmartWebService = document.querySelector('dcf-smartweb-service');
        }
        Promise.resolve(dcfSmartWebService.getDataCollectionSchema()).then(
          (obj) => {
            if (!dcfSmartWebService.isEmpty(obj)) {
              obj.tealiumeventtype = tealiumEventType;
              obj.digital.tms.environment = TEALIUM_ENV;
              obj.digital.tms.profile = TEALIUM_PROFILE;
              obj.page.pageinfo.name = data.pageName;
              obj.page.pageinfo.subcategory1 = "Aadvantage Business";
              obj.page.pageinfo.primarycategory = SITE_INDICATOR;
              obj.digital.app.name = "Universal Connect";
              obj.digital.app.alias = APP_ALIAS;
              obj.digital.app.version = "0.1.0";
              //custom data setup
              obj.customerloyalty.customer.status = userContext?.loggedIn ? "Logged_in" : "Logged_out";
              obj.digital.server.location = "US-EAST";
              obj.digital.server.name = "AA-CFCDN";
              obj.customerloyalty.customer.id = userContext?.loggedIn && userContext?.userInfo?.providerUserAssignment?.length > 0 ? userContext?.userInfo?.providerUserAssignment[0]?.membershipNumber : "";
              if (!obj.customerloyalty.attributes) {
                obj.customerloyalty.attributes = {}
              }
              obj.customerloyalty.attributes.role = userContext?.loggedIn ? (userContext?.userInfo?.companyInfo?.RoleId && parseInt(userContext?.userInfo?.companyInfo?.RoleId) === 8 ? "ATM" : "BT") : "";
              obj.customerloyalty.attributes.type = userContext?.loggedIn ? "Aadvb" : "";
              dcfSmartWebService.initDataCollectionObj(obj);
              setUserContext({
                initAnalytics: true
              })
            }
          },
          (error) => {
            console.error('Error: initAnalytics() ' + error);
          }
        )
      }
    }
  }

  const updateAnalytics  = ( data, dcfCallType, tealiumEventType )  => {

    customElements.whenDefined('dcf-smartweb-service').then(async () => {
      dcfSmartWebService = document.querySelector('dcf-smartweb-service');
      dcfSmartWebService.getDataCollectionObj().subscribe((obj) => {
        if (!dcfSmartWebService.isEmpty(obj)) {
          obj.tealiumeventtype = tealiumEventType;
          obj.customerloyalty.customer.id = userContext?.loggedIn ? userContext?.userInfo?.providerUserAssignment?.[0]?.membershipNumber :"";
          obj.customerloyalty.attributes.role = userContext?.loggedIn ? (userContext?.userInfo?.companyInfo?.RoleId === 8 ? "ATM" : "BT") : " ";
          obj.customerloyalty.attributes.type = userContext?.loggedIn ? "Aadvb" : "";
          obj.page.pageinfo.name = data.pageName;
          dcfSmartWebService.updateDataCollectionObj(obj);
        }
      }, (error) => {
        console.error('Error: updateAnalytics() ' + error);
      });
    })
  }

  return {
    initAnalytics
  };
}

